import { concatAll } from 'lib/util';

// creates an array of arrays of content (only if content exists in that bucket)
// flattens that array of arrays using "concatAll"
export default (content = {}, buckets = []) => {
    let contentIndex = 0;   // this should really never be used, but default to 0
    // if there are no buckets, create a single item playlist of the content
    if (buckets.length === 0) {
        return [{
            id: content.guid,
            headline: content.name,
            poster: content.imageHref
        }];
    }
    return concatAll(
        buckets.filter((bucket) => {
            let contains = false;
            bucket.contents.forEach((bucketContent, index) => {
                if (bucketContent.id === content.id) {
                    if (content.bucketId) {
                        if (content.bucketId === bucket.id) {
                            contains = true;
                            contentIndex = index;
                        }
                    } else {
                        contains = true;
                        contentIndex = index;
                    }
                }
            });
            return contains;
        }).map((bucket) => bucket.contents.slice(contentIndex, bucket.contents.length)
            .map((bucketContent) => {
                const { guid: id = null, name: headline = null, imageHref: poster = null } = bucketContent;
                if (id && headline && poster) {
                    return {
                        id,
                        headline,
                        poster
                    };
                }
                return {};
            })
        )
    );
};



// WEBPACK FOOTER //
// ./app/player/util/getContentPlaylistFromBuckets.js